"use strict";

module.exports = constant;

function constant(a) {
  return _ => a;
}